import { AnalyticsListener as AKAnalyticsListener } from '@atlaskit/analytics-next';
import * as Immutable from 'immutable';
import PropTypes from 'prop-types';
import * as React from 'react';

import {
  trackAddonDiscovery as aceTrackAddonDiscovery,
  trackEvent,
} from 'common/utils/analytics/aceAnalytics';
import { trackEvent as gaTrackEvent } from 'common/utils/analytics/analytics';

const WHITELISTED_CHANNELS = {
  AddonDiscovery: 'addonDiscovery',
  Marketplace: 'marketplace',
};

class AnalyticsListener extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
  };

  onEvent = (event, channel) => {
    if (channel === WHITELISTED_CHANNELS.AddonDiscovery) {
      const p = event.payload;
      const label = p?.label
        ? p.label
        : Immutable.List([p.objectType, p.objectId])
            .filter(Boolean)
            .join(':');
      const contexts = Immutable.List(event.context);
      const { actionSubject, action, actionSubjectId } = p.eventType;
      const gaValue = contexts.reduce(
        (acc, c) => (c.gaValueKey ? Immutable.Map(p).getIn(c.gaValueKey) : acc),
        null
      );
      const gaCategory = contexts.reduce((acc, c) => c.gaCategory || acc, 'AddonDiscovery');

      gaTrackEvent(gaCategory, `${actionSubject} ${action} ${actionSubjectId}`, label, gaValue);
      aceTrackAddonDiscovery({
        eventName: `${p.eventType.actionSubject} ${p.eventType.action}`,
        actionSubject,
        actionSubjectId,
        action,
        label,
        payload: p,
      });
    }

    if (channel === WHITELISTED_CHANNELS.Marketplace) {
      const payload = event.payload || {};
      const context = event.context || {};
      const { actionSubject, action } = payload.eventType || {};
      const allContexts = context.reduce(
        (allContext, nextContent) => ({ ...allContext, ...nextContent }),
        {}
      );
      trackEvent({
        eventName: `${actionSubject} ${action}`,
        eventComponent: actionSubject,
        event: action,
        actionSubjectId: payload.actionSubjectId,
        poweredBy: 'AMKT_FRONTEND',
        ...allContexts,
        ...payload.attributes,
      });
    }
  };

  render() {
    return (
      <AKAnalyticsListener channel="*" onEvent={this.onEvent}>
        {this.props.children}
      </AKAnalyticsListener>
    );
  }
}

export default AnalyticsListener;
